import React from 'react';
import PaymentResultSummary from '../PaymentResultSummary';
import PaymentResultDetail from '../PaymentResultDetail';

const FullInfoPaymentResult = ({
  isShowOrderDetail, totalAmount, orderDescription, businessDate, orderReviewModel, orderPaymentResultList,
  currencyCode, locale, trackingCallback, confirmationMsg, confirmationMsgsForAgencies, toggleDetail,
}) => {
  return isShowOrderDetail ? <PaymentResultDetail
    totalAmount={totalAmount}
    currencyCode={currencyCode}
    locale={locale}
    trackingCallback={trackingCallback}
    confirmationMsg={confirmationMsg}
    confirmationMsgsForAgencies={confirmationMsgsForAgencies}
    orderDescription={orderDescription}
    toggleDetail={toggleDetail}
    businessDate={businessDate}
    orderReviewModel={orderReviewModel}
    orderPaymentResultList={orderPaymentResultList}/>
    : <PaymentResultSummary
      totalAmount={totalAmount}
      currencyCode={currencyCode}
      locale={locale}
      confirmationMsg={confirmationMsg}
      confirmationMsgsForAgencies={confirmationMsgsForAgencies}
      orderDescription={orderDescription}
      toggleDetail={toggleDetail}
      businessDate={businessDate}
      orderReviewModel={orderReviewModel}
      orderPaymentResultList={orderPaymentResultList}/>;
};

export default FullInfoPaymentResult;
